export default "__VITE_ASSET__Ba2uU_o___"